import { Button } from "@mui/material";
import { Card, Col, Form, Row } from "react-bootstrap";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Dialog, Modal } from "antd-mobile";
import React, { useContext, useState } from "react";
import PsContext from "../../context";
import {
  getFileLiveUrl,
  MOB_ICONS,
  momentDate,
  sleep,
  upperCase,
} from "../../utils";
import Header from "../header";
import UpdatePassword from "./updatePassword";

const MyProfile = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  const lockClick = () => {
    Dialog.confirm({
      content: "Do you want to lock?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        await sleep(2000);
        context.logout(true);
        //window.location.reload(true);
      },
    });
  };

  const logoutClick = () => {
    Dialog.confirm({
      content: "Do you want to logout?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        await sleep(2000);
        context.logout();
        context.updateMobileUserId("");
        context.updateMobilePassword("");
        context.setStorage("employee_name", "");
      },
    });
  };

  const userPhoto = () => {
    if (
      context.user &&
      context.user.emp_profile_photo &&
      context.user.emp_profile_photo.length > 5
    )
      return getFileLiveUrl(context.user.emp_profile_photo);

    let gender = upperCase(context.user.emp_gender);
    if (gender == "MALE") return MOB_ICONS.MAN_256;
    else if (gender == "FEMALE") return MOB_ICONS.WOMAN_256;
  };

  const changePassClick = () => {
    Modal.show({
      title: "Update Password",
      content: (
        <UpdatePassword
          onSuccess={(d) => {
            Modal.clear();
          }}
        />
      ),
      //closeOnMaskClick: true,
      showCloseButton: true,
    });
  };
  return (
    <>
      <Header backAction={true} title="My Profile" />
      <div className="container-sm py-md-3">
        <div className="profile-container" style={{ height: "150px" }}></div>
        <div
          className="d-flex justify-content-center align-content-center"
          style={{ marginTop: "-75px" }}
        >
          <img
            className=""
            style={{
              width: "100%",
              maxWidth: "170px",
              height: "190px",
              borderRadius: "50%",
              border: "4px solid white",
              zIndex: "1",
            }}
            src={userPhoto()}
          />
        </div>
        <div className="" data-aos="zoom-in">
          <div className="container-sm py-md-3">
            <div className="py-2"></div>
            <Card>
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                Personal Information
              </Card.Header>
              <Card.Body>
                <Row className="">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Name <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={context.user.employee_name}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      DOB <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={momentDate(context.user.emp_dob, "DD-MMM-YYYY")}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Mobile <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={context.user.emp_personal_mobile}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Email <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={context.user.emp_personal_mail}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Address <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={context.user.emp_current_address}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </div>

        <div className="container mt-5 text-center">
          <Button
            size="large"
            variant="contained"
            className="bg-theme me-2"
            startIcon={<LockOutlinedIcon />}
            onClick={(e) => logoutClick()}
          >
            Logout
          </Button>
          <Button
            size="large"
            variant="contained"
            className="bg-theme ms-2"
            startIcon={<LockOutlinedIcon />}
            onClick={(e) => lockClick()}
          >
            Lock
          </Button>
        </div>
      </div>
    </>
  );
};
export default MyProfile;
